export default __webpack_public_path__ + "static/media/data.12417f69.svg";